<div class="container-fluid-page">
  <div
    class="d-flex page__box p-3 mt-2"
    style="margin-top: 80px; color: white; font-size: 26px"
  >
    &nbsp;&nbsp;Manage Crop
  </div>
  <div class="profile_details">
    <div class="button" style="float: right; margin-top: -65px !important">
      <button class="close" mat-button (click)="onClear()">X</button>
    </div>

    <div class="page__content shadow p-3">
      <form [formGroup]="addCropName" (ngSubmit)="onSubmit()">
        <mat-form-field class="category-name w-full" appearance="fill">
          <mat-label
            class="name"
            style="color: black; height: 5px; margin-left: 18px"
            >Name</mat-label
          >
          <input
            matInput
            placeholder="Crop name goes here"
            autocomplete="off"
            formControlName="cropName"
          />
        </mat-form-field>
        <button mat-raised-button class="btn btnadd manageCroptBtn">Add</button>
      </form>
      <div class="category-list-section">
        <div class="category-header d-flex w-full">
          <span class="name-label">Crop</span>&nbsp;&nbsp;
          <mat-icon (click)="deleteCrop()">delete</mat-icon>
        </div>
        <div
          class="category-content"
          [ngClass]="cropDataList?.length > 8 ? 'overflow' : ''"
        >
          <div class="round">
            <!-- {{categorydatalist|json}} -->
            <div
              *ngFor="let items of cropDataList"
              class="category-list d-flex w-full"
            >
              <span class="name-label">{{ items.cropName }}</span>
              <!-- <span > -->
              <mat-checkbox
                *ngIf="items.cropName !== 'Coconut'"
                name="list_name"
                (change)="itemToDelete(items, $event)"
              ></mat-checkbox>
              <!-- </span> -->
            </div>
          </div>
        </div>
      </div>
      <hr style="height: 1px" />
      <div
        class="button"
        style="float: right; margin-top: -20px !important"
      ></div>
    </div>
  </div>
  <style>
    .page__content {
      min-height: calc(56vh - 80px) !important;
      border-radius: 10px;
      margin-top: -2rem;
      background: white;
      color: black;
      font-size: 2rem;
    }

    .container-fluid {
      height: 60%;
      /* margin-top: -1rem; */
    }

    .name {
      height: 10px;
    }
  </style>
</div>
